import { dodgeInstance as Axios} from "./axios.service";

const APIService = {
  getTripTypes(organisation) {
    return Axios({
      method: 'GET',
      url: `/booking-service/booking/booking-organisation-profile/get_organisation_trip_type/`,
      headers: { organisation }
    });
  },
  getExtras(organisation) {
    return Axios({
      method: 'GET',
      url: `/booking-service/booking/booking-organisation-profile/get_extras/`,
      headers: { organisation }
    });
  },
  individualTripPayment(id, callbackUrl, token, organisation) {
    return Axios({
      method: 'GET',
      url: `/booking-service/booking/booking-trip/${id}/checkout/?callback=${callbackUrl}`,
      headers: { Authorization: `Bearer ${token}`, organisation}
    });
  },
  businessTripPayment(id, callbackUrl, token, entity, organisation) {
    return Axios({
      method: 'GET',
      url: `/entity-service/business/business-tripset/${id}/checkout/?callback=${callbackUrl}`,
      headers: { Authorization: `Bearer ${token}`, entity, organisation}
    });
  },
}

export default APIService;